// 生产安全事故
import areaOptions from '@utils/pca.json';
import axios from '@/axios';
const defaultQueryParams = {
  page: 1,
  pageSize: 10,
  startTime: '',
  endTime: '',
  accidentTypes: [],
  managementCategories: [],
  accidentUnit: '',
  accidentLevel: '',
  keyword: '',
};
const levels = ['特别重大事故', '重大事故', '较大事故', '一般事故'];
export default {
  namespaced: true,
  state: {
    kbId: 245, // 知识库id
    kbName: '事故案例(其他)', // 知识库名称
    areaOptions, // 地域列表
    levelOptions: levels.map((x) => {
      return { label: x, value: x };
    }),
    typeOptions: [], // 事故类型列表
    industryOptions: [], // 事故行业领域列表
    totalCount: 0, // 查询结果数量
    accidentStatisticsData: {
      totalCount: 0,
      specialGreatAccidentCount: 0,
      greatAccidentCount: 0,
      largerAccidentCount: 0,
      generalAccidentCount: 0,
    }, // 事故统计数据
    selection: [], // 表格多选列表
    tableData: [], // 查询结果列表数据
    queryParams: { ...defaultQueryParams }, // 分页查询参数
    eventobj: null,
    isconn: false,
    sessions: [{ content: '您好，我是AI安全助手，帮您快速了解安全事故，有什么问题可以直接问我。' }], // 对话记录
  },
  mutations: {
    addSessions(state, result) {
      // 添加聊天记录
      state.sessions.push(result);
    },
    setQueryParams(state, data) {
      // 设置分页查询参数
      state.queryParams = data || { ...defaultQueryParams };
    },
    setSelection(state, data) {
      // 设置表格多选列表
      state.selection = data;
    },
    setConn(state) {
      // 抽取文件内容
      state.eventobj.close();
      state.isconn = false;
    },
  },
  actions: {
    async getAccidentStatisticsData({ state }) {
      // 获取事故案例统计数据
      const { code, data } = await axios.post('/api/accident/production-safety/statistics');
      if (code == 200) state.accidentStatisticsData = data;
    },
    async getWeeklyReport({ state }, yearMonth) {
      // 周报
      const { code, data } = await axios.post(`/api/accident/production-safety/weekly-report/${yearMonth}`);
      if (code == 200) return data;
    },
    async getMonthReport({ state }, year) {
      // 月报
      const { code, data } = await axios.post(`/api/accident/production-safety/monthly-report/${year}`);
      if (code == 200) return data;
    },
    async getAutoReport({ state }, request) {
      // 获取自动报告
      return await axios.post(`/api/accident/production-safety/doc-report`, request);
    },
    async getAccidentType({ state }) {
      // 获取事故类型
      const { data } = await axios.get('/api/accidentCase/getAccidentType');
      if (data instanceof Array)
        state.typeOptions = data.map((x) => {
          return { label: x, value: x };
        });
    },
    async getAccidentIndustryArea({ state }) {
      // 获取事故行业领域
      const { data } = await axios.get('/api/accidentCase/getAccidentIndustryArea');
      if (data instanceof Array)
        state.industryOptions = data.map((x) => {
          return { label: x, value: x };
        });
    },
    async accidentCasePage({ state }) {
      // 获取分页数据
      if (!state.queryParams.startTime) state.queryParams.startTime = null;
      if (!state.queryParams.endTime) state.queryParams.endTime = null;
      const { data } = await axios.post('/api/accident/production-safety/page', { ...state.queryParams });
      if (data && data.list instanceof Array) {
        state.totalCount = parseInt(data.totalCount) || 0;
        console.log(data.list);
        state.tableData = data.list.sort(
          (a, b) => new Date(b.accidentTime).getTime() - new Date(a.accidentTime).getTime()
        );
      }
    },
    async update({ state }, data) {
      // 修改文档集
      const { code } = await axios.post('/api/accident/production-safety/edit', data);
      if (code == 200) {
        state.queryParams = { ...state.queryParams };
        return true;
      }
    },
    async removeBatch({ state }, ids) {
      // 批量删除
      const { code } = await axios.post('/api/accident/production-safety/delete', ids);
      if (code == 200) {
        state.queryParams = { ...state.queryParams };
        return true;
      }
    },
    async getAnalysePieChartData(store, ids) {
      // 获取分析-饼图数据
      const { data } = await axios.post('/api/accident/production-safety/getAnalysePieChartData2', ids);
      return data;
    },
    async searchOfficialAccounts({ state }, keyword) {
      // 搜索公众号列表
      const { data } = await axios.get(
        `/api/trainingPromotionCenter/select_wechat_official_account?query=${keyword}&page=1`
      );
      return data instanceof Array
        ? data.map((x) => {
            return { value: x.nickname, head: x.round_head_img, fakeid: x.fakeid };
          })
        : [];
    },
    async createDocument({ state }, data) {
      // 创建文档-事故案例
      const { code } = await axios.post('/api/accidentCase/createDocument', { ...data, knowledgeBaseId: state.kbId });
      if (code == 200) {
        state.queryParams = { ...state.queryParams };
        return true;
      }
    },
    async createWebGather({ state }, data) {
      // 网页采集
      const { code } = await axios.post('/api/accidentCase/add_html_to_doc', { ...data, kbId: state.kbId });
      if (code == 200) {
        state.queryParams = { ...state.queryParams };
        return true;
      }
    },
    async createOfficialAccountGather({ state }, data) {
      // 公众号采集
      const { code } = await axios.post('/api/accidentCase/select_wechat_official_account_article', {
        ...data,
        kbId: state.kbId,
      });
      if (code == 200) {
        state.queryParams = { ...state.queryParams };
        return true;
      }
    },
    async uploadFileToServe({ state }, file) {
      // 上传文件到服务器
      var formData = new FormData();
      formData.append('files', file);
      formData.append('knowledgeBaseId', state.kbId);
      const { code, data } = await axios.post('/api/accidentCase/uploadFilesSync', formData);
      return code == 200 ? data : '';
    },
    async uploadFileToKnowledgeBase({ state }, file) {
      // 上传文件到知识库并进行向量化
      var formData = new FormData();
      formData.append('files', file);
      formData.append('knowledge_base_name', state.kbName);
      const { code } = await axios.post('/klgapi/knowledge_base/upload_docs', formData);
      return code == 200;
    },
    async extractFileInfo({ state }, fileurl) {
      // 抽取文件内容
      const { data } = await axios.post('/klgapi/tool/extract_file_info', { fileurl, type: '事故案例' });
      return data;
    },
    async sendQuestion({ state }, query) {
      // 发送问题
      return new Promise((resolve, reject) => {
        state.sessions.push({ content: query, self: true });
        const obj = { content: '思考中。。。', loading: true, cancel: false };
        state.sessions.push(obj);
        let count = 0;
        const timer = setInterval(() => {
          if (obj.loading && count < 300) {
            if (obj.cancel) {
              obj.loading = false;
              obj.content = '已取消';
              if (state.eventobj) {
                state.eventobj.close();
                delete state.eventobj;
              }
              reject();
            } else {
              let text = '思考中 ';
              for (let i = 0; i < count % 4; i++) text += '。';
              obj.content = text;
              count++;
            }
          } else clearInterval(timer);
        }, 200);

        // 非流式响应接口
        // const res = await axios.post('/klgapi/chat/aiwrite_chat', { query, source: '生产安全事故案例' })
        // clearInterval(timer)
        // state.sessions[state.sessions.length - 1].content = res

        //流式响应接口
        state.eventobj = new EventSource(`/queapi/robot_writing/writings?source=生产安全事故案例&query=${query}`);
        state.eventobj.onopen = () => {
          obj.content = '';
        };
        state.eventobj.onmessage = (event) => {
          clearInterval(timer);
          state.isconn = true;
          obj.loading = false;
          if (event.data == '[DONE]') {
            state.isconn = false;
            state.eventobj.close();
            delete state.eventobj;
            resolve();
            return;
          }
          obj.content += event.data.replaceAll('&nbsp;', '').replaceAll('\\n', '\n');
        };
        state.eventobj.onerror = () => {
          clearInterval(timer);
          obj.loading = false;
          obj.content = '请求错误！';
          state.eventobj.close();
          delete state.eventobj;
          reject();
        };
      });
    },
  },
};
